
import React, { useState } from "react";
import AnimateFromBottom from "./AnimateFromBottom";
import language from "../../../helpers/language";

const Faq = () => {
  const [lang] = useState(language.getLang());
  const faqArray = lang.faqItems;
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <section className="md:px-14 px-4 md:py-16 py-10">
      <div className="max-w-5xl mx-auto">
        <AnimateFromBottom delay={0.2}>
          <div className="flex justify-center mb-6">
            <span className="border border-royal text-royal text-xs font-semibold px-5 py-1.5 rounded uppercase">
              FAQ
            </span>
          </div>
        </AnimateFromBottom>

        <AnimateFromBottom delay={0.3}>
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 text-center">
            {lang.faq}
          </h2>
        </AnimateFromBottom>

        <div style={{ height: '48px' }} />

        <AnimateFromBottom delay={0.4}>
          <div className="flex flex-col gap-4">
            {faqArray?.map((item, index) => {
              const isOpen = activeIndex === index;
              return (
                <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left"
                  >
                    <span className="font-semibold text-base text-gray-900">{item.title}</span>
                    <span className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${isOpen ? 'bg-royal' : 'bg-gray-100'}`}>
                      <i className={`fa text-xs ${isOpen ? 'fa-arrow-up text-white' : 'fa-arrow-down text-gray-500'}`} />
                    </span>
                  </button>

                  {isOpen && (
                    <div className="px-6 pb-6">
                      <p className="text-sm text-gray-500 leading-relaxed">{item.description}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </AnimateFromBottom>
      </div>
    </section>
  );
};

export default Faq;
